import React from 'react';
import JoinTheTribe from './joinTheTribe'
import SpiritOfTribe from './spiritOfTribe'
import TalkOfTribe from './talkOfTribe'
import PerksOfTribe from './perksOfTribe'
import OppurtunitiesInTribe from './oppurtunitiesInTribe'

const Careers = () => {
  return ( 
    <div>
      < JoinTheTribe />
      < SpiritOfTribe />
      < TalkOfTribe />
      < PerksOfTribe />
      < OppurtunitiesInTribe />
    </div>
   );
}
 
export default Careers;